import dayjs from 'dayjs';
import { DeliveryDaysValue, DeliveryTimeValue } from '../hooks/App/useSubscriptionFirst';
import { Plan } from '../hooks/SubscriptionDetail/useDeliveryPlan';

const formatStatusMessage = (status: string) => {
  switch (status) {
    case 'ACTIVE': return 'アクティブ';
    case 'PAUSED': return '一時停止';
    case 'CANCELLED': return '解約';
    case 'EXPIRED': return '期限切れ';
    case 'FAILED': return '失敗';
    default: return '不明なステータス';
  }
}

const formatPlanInterval = (plan: Plan) => {
  const unit = formatBillingPolicyInterval(plan.billingPolicyInterval);
  return `${plan.billingPolicyIntervalCount}${unit}に1回`;
}

const formatBillingPolicyInterval = (value: string) => {
  switch (value) {
    case 'DAY': return '日';
    case 'WEEK': return '週';
    case 'MONTH': return 'ヶ月';
    case 'YEAR': return '年';
    default: return '';
  }
}

const formatDeliveryDateFromDayjs = (date: dayjs.Dayjs | Date) => {
  return dayjs.isDayjs(date)
    ? date.format('YYYY年M月D日') 
    : dayjs(date).format('YYYY年M月D日');
}

const formatDeliveryTime = (value: DeliveryTimeValue) => {
  switch (value) {
    case 'AM': return '午前中';
    case '12': return '12:00〜14:00';
    case '14': return '14:00〜16:00';
    case '16': return '16:00〜18:00';
    case '18': return '18:00〜20:00';
    case '19': return '19:00〜21:00';
    case '20': return '20:00〜21:00';
    default: return '不明な時間帯';
  }
}

const formatDeliveryDays = (value: DeliveryDaysValue) => {
  switch (value) {
    case 'Mon': return '月';
    case 'Tue': return '火';
    case 'Wed': return '水';
    case 'Thr': return '木';
    case 'Fri': return '金';
    case 'Sat': return '土';
    case 'Mon': return '日';
  }
}

const formatCardBrandName = (brand: string) => {
  switch (brand.toUpperCase()) {
    case 'AMERICAN_EXPRESS': return 'American Express';
    case 'DINERS_CLUB': return 'Diners Club';
    case 'JCB': return 'JCB';
    case 'MASTERCARD':return 'MASTERCARD';
    case 'VISA': return 'VISA';
    default: return '不明';
  }
};

const formatShippingAddress = (name: string) => {
  switch (name) {
    case 'lastName': return '姓';
    case 'firstName': return '名';
    case 'phone': return '電話番号';
    case 'zip': return '郵便番号';
    case 'countryCode': return '国/地域';
    case 'provinceCode': return '都道府県';
    case 'city': return '市町村区';
    case 'address1': return '住所';
    case 'address2': return '建物名・部屋番号など';
    case 'company': return '会社名';
    default: return '';
  }
};

export {
  formatStatusMessage,
  formatDeliveryDateFromDayjs,
  formatPlanInterval,
  formatDeliveryTime,
  formatDeliveryDays,
  formatCardBrandName,
  formatShippingAddress
}